import React from "react";
import FavouriteTemplates, {
  FavouriteTemplatesProps,
} from "./FavouriteTemplates";
import useBooleanState from "../../../../../hooks/utils/useBooleanState";

type FavouriteTemplatesStateContainerProps = Omit<
  FavouriteTemplatesProps,
  "isOpen" | "toggleOpen"
>;
const FavouriteTemplatesStateContainer = (
  props: FavouriteTemplatesStateContainerProps
) => {
  const [isModalOpen, toggleModal] = useBooleanState(false);

  return (
    <FavouriteTemplates
      {...props}
      isOpen={isModalOpen}
      toggleOpen={toggleModal}
    />
  );
};

export default FavouriteTemplatesStateContainer;
